var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.isLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('v-btn',{attrs:{"disabled":_vm.selected.length === 0,"outlined":"","color":"accent"},on:{"click":_vm.handleBulkDelete}},[_vm._v(" "+_vm._s(_vm.$t("actions.delete"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }